import React, {useState} from "react";
import {
    Create,
    TabbedForm,
    FormTab,
    TextInput,
    SelectInput,
    BooleanInput,
    AutocompleteInput,
    DateInput,
    Toolbar,
    FormDataConsumer,
} from 'react-admin';
import CityAutoCompleteInputCustom from "../component/CityAutoCompleteInputCustom";
import StreetAutoCompleteInputCustom from "../component/StreetAutoCompleteInputCustom";
import RegionAutoCompleteInputCustom from "../component/RegionAutoCompleteInputCustom";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText
} from '@material-ui/core';
import ButtonMui from '@material-ui/core/Button';
import SaveButtonAware from "../component/SaveButtonAware";
import streetTypes from "../helper/StreetTypes";
import areas from "../helper/Areas";
import { Paper, Typography, AppBar, Tabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PhoneArrayInput from "../component/PhoneArrayInput";
import required from "../helper/Required";
import LogoutButton from "../component/LogoutButton";
import "./styles/main.css"
import Styles from "./Styles";
import LoadingComponent from "../component/LoadingComponent";
import errorMessage from "../helper/ErrorMessage";
import SignComponent from "../component/SignComponent";
import SignedRequest from '../component/SignedRequest';

const LegalEntityCreate = props => {
    const useStyles = makeStyles((theme) => (Styles));
    const [dialogOpen, setDialogOpen] = useState(false);
    const [loadedData, setLoadedData] = useState({});
    const [record, setRecord] = useState({});
    const [licenseId, setLicenseId] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [loading, setLoading] = useState(false);
    const classes = useStyles();

    let timer = null;
    let keyCallbacks = null;

    const handleOpen = () => {
        setDialogOpen(true);
    };

    const handleClose = () => {
        setDialogOpen(false);
    };

    const handleClick = () => {
        setRecord(loadedData);
        handleClose();
    }

    const handleLicenseClick = value => {
        setLicenseId(!licenseId);
    }

    const popupAlert = (message) => {
        setAlertOpen(true);
        setAlertText(message);
    };

    const handleAlertClose = () => {
        setAlertOpen(false);
    };

    const searchLegalEntity = (event) => {
        const value = event.target.value;

        if (
            !value
            || (value.length !== 10 && value.length !== 8)
        ) {
            return;
        }

        const requestOptions = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                'X-Session': localStorage.getItem('session')
            }
        };

        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(function () {
            fetch(
                process.env.REACT_APP_API_ENTRYPOINT + '/legal_entities?common=1&edrpou=' + value,
                requestOptions
            )
            .then(response => {
                if (response.status >= 400) {
                    return Promise.reject();
                }

                return response.json();
            })
            .then(data => {
                if(
                    typeof data !== 'object'
                    || data.length === 0
                ) {
                    return;
                }

                let item = null;

                if (data.length > 0) {
                    item = data[0];
                }

                for (let i = 0; i < data.length; i++) {
                    if (data[i].type === 'PHARMACY') {
                        item = data[i];
                    }
                }

                if (item) {
                    if (item.residenceAddress) {
                        //item.residenceAddress.street = null;
                    }
                    setLoadedData(item);
                }

                handleOpen();
            });
        }, 900);
    };

    const handleSave = (values, redirect) => {
        values.id = null;
        setLoading(true);

        if (typeof values.tab ==='undefined' || values.tab === 0) {
            values.signType = 'file';
            processFileKey(values);
        } else if (values.tab === 1) {
            values.signType = 'hardware';
            processHardwareKey(values);
        } else if (values.tab === 2) {
            values.signType = 'gryada';
            values.inn = values.owner?.tax_id;
            processGryadaKey(values);
        }
    };

    const processFileKey = (values) => {
        const reader = new FileReader();
        reader.onloadend = async event => {
            values.keyStore = event.target.result;
            let fileParts = values.sign.title.split('.');
            values.extension = fileParts[fileParts.length - 1];

            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                    'X-Session': localStorage.getItem('session')
                },
                body: JSON.stringify(values)
            };

            try {
                const response = await fetch(
                    process.env.REACT_APP_API_ENTRYPOINT + '/legal_entities?common=1',
                    requestOptions
                );

                const data = await response.json();

                if (data.success) {
                    popupAlert('Запит успішно відправлений.');
                } else {
                    errorMessage(data, popupAlert);
                }
                setLoading(false);
            } catch (e) {
                popupAlert('Помилка надсилання запиту');
                setLoading(false);
            }
        }

        reader.readAsDataURL(values.sign.rawFile);
    };

    const processHardwareKey = (values) => {
        const formData = {
            ca: values.ca,
            signPath: values.signPath,
            password2: values.password2
        };

        keyCallbacks.verify(formData, async (data) => {
            if (!data.keyAgreement?.canBeUsed || !data.signature?.canBeUsed) {
                popupAlert('Помилка зчитування КЕП');
                setLoading(false);
                return;
            }

            await SignedRequest(
                values,
                keyCallbacks,
                formData,
                process.env.REACT_APP_API_ENTRYPOINT + '/legal_entities?common=1&onlySerialize=1',
                process.env.REACT_APP_BASE_ENTRYPOINT + '/legal_entities/save?common=1',
                popupAlert,
                setLoading
            );
        });
    };

    const processGryadaKey = async (values) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                'X-Session': localStorage.getItem('session')
            },
            body: JSON.stringify(values)
        };

        try {
            const response = await fetch(
                process.env.REACT_APP_API_ENTRYPOINT + '/legal_entities?common=1',
                requestOptions
            );

            const data = await response.json();

            if (data.success) {
                popupAlert('Запит успішно відправлений.');
            } else {
                errorMessage(data, popupAlert);
            }
            setLoading(false);
        } catch (e) {
            popupAlert('Помилка надсилання запиту');
            setLoading(false);
        }
    }

    const keyMounted = (callbacks) => {
        keyCallbacks = callbacks;
    };

    const LegalEntityCreateToolbar = props => (
        <Toolbar {...props}>
            <div className="toolbar-wrapper">
                <div>
                    <Paper elevation={3} className="public-offer" label="Публічна оферта" source="publicOffer.consentText" multiline validate={required.validateRequired} fullWidth={true} >Відповідно до Закону України “Про захист персональних даних” з метою ведення реєстрів електронної системи охорони здоров’я та забезпечення її функціонування у дослідній експлуатації надаю згоду обраному оператору та адміністратору електронної системи охорони здоров’я на обробку моїх персональних даних з первинних джерел, а також на здійснення дій, пов’язаних зі збиранням, реєстрацією, накопиченням, зберіганням, адаптуванням, зміною, поновленням, використанням, поширенням, розповсюдженням, реалізацією, передачею, знеособленням, знищенням будь-яких відомостей. Додатково надаю згоду на доступ до моїх персональних даних уповноважених третіх осіб, що визначає дії оператора МІС та адміністратора у разі отримання запиту від уповноваженої третьої особи щодо надання доступу до персональних даних. Підтверджую достовірність вказаних мною даних та добровільність надання цих даних до електронної системи охорони здоров’я, що працює у дослідній експлуатації. Усвідомлюю, що у випадку надання мною недостовірної інформації, мені може бути відмовлено у реєстрації в електронній системі охорони здоров’я. Зобов’язуюсь дотримуватись Регламенту функціонування електронної системи охорони здоров’я.</Paper>
                    <BooleanInput className="tab-content-item-boolean-input" label="Підтверджую" source="publicOffer.consent" />

                    <SignComponent {...props} onMounted={callbacks => keyMounted(callbacks)} />
                </div>
                <div className="toolbar-button-section">
                    {loading ? <LoadingComponent /> : <SaveButtonAware onSave={handleSave} label="Відправити запит" {...props} />}
                </div>

                <Dialog
                    open={alertOpen}
                    onClose={handleAlertClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-content">
                            {alertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <ButtonMui onClick={handleAlertClose} color="primary">
                            OK
                        </ButtonMui>
                    </DialogActions>
                </Dialog>
            </div>
        </Toolbar>
    );

    const Title = props => (
        <div className="title-wrapper">
            <LogoutButton />
            <span className="title-text">Реєстрація Юридичної особи або ФОП</span>
        </div>
    );

    const requiredStringValue = () =>
        value => (!(/^(?!.*[ЫЪЭЁыъэё@%&$^#])[А-ЯҐЇІЄа-яґїіє0-9’\\'\\\/ -]+$/.test(value)) && !!value) ? 'поле повинно містити тільки літери українського алфавіту, цифри, символи №, ", (, ), - і пробіл' :  undefined;

    const validationFunc = [requiredStringValue()];

    const requiredStringValueName = () =>
        value => (!(/^(?!.*[ЫЪЭЁыъэё@%&$^#])[А-ЯҐЇІЄа-яґїіє’\\'\\ -]+$/.test(value)) && !!value) ? 'поле повинно містити тільки літери українського алфавіту або символи ’, \', - і пробіл' :  undefined;

    const validationFuncName = [requiredStringValueName()];

    return (
        <Create {...props} record={record} title={<Title {...props} />}>
            <TabbedForm toolbar={<LegalEntityCreateToolbar {...props} />} validate={(values) => required.validateLegalEntityCreation(values, licenseId)}>
                <FormTab contentClassName="legal-entities-tab-content" label={<span>Загальна інформація <sup>*</sup></span>}>
                    <TextInput formClassName="tab-content-item" label="Код ЄДРПОУ або ІПН" source="edrpou" validate={required.validateRequiredTaxNumber} options={{onKeyUp: searchLegalEntity}} onChange={searchLegalEntity} />
                    <SelectInput formClassName="tab-content-item" label="Тип закладу охорони здоров'я" source="type" validate={required.validateRequired} choices={[
                        { id: 'PHARMACY', name: 'Аптека' }
                    ]} />
                    <TextInput formClassName="tab-content-item" label="E-mail" source="email" validate={required.validateRequiredEmail} />
                    <TextInput formClassName="tab-content-item" label="Веб-сторінка" source="website" />
                    <TextInput formClassName="tab-content-item" label="Код одержувача бюджетних коштів" source="receiverFundsCode" />
                    <TextInput formClassName="tab-content-item" label="ПІБ власника" source="beneficiary" />

                    <DateInput formClassName="tab-content-item" label="Дата внесення в архів" source="archive.date" />
                    <TextInput formClassName="tab-content-item" label="Адреса місцезнаходження архіву" source="archive.place"  />
                </FormTab>

                <FormTab contentClassName="legal-entities-tab-content" label={<span>Адреса <sup>*</sup></span>}>
                    <SelectInput formClassName="tab-content-item" label="Область" source="residenceAddress.area" choices={areas} validate={required.validateRequired} />
                    <RegionAutoCompleteInputCustom formClassName="tab-content-item autocomplete help-text-custom" label="Район" source="residenceAddress.region" />

                    <CityAutoCompleteInputCustom formClassName="tab-content-item autocomplete help-text-custom" label="Населений пункт" source="residenceAddress.settlementId" validate={required.validateRequired} />
                    <FormDataConsumer formClassName="tab-content-item">
                        {({ formData, ...rest }) => (
                    <SelectInput
                        initialValue={formData.residenceAddress?.streetType ? formData.residenceAddress?.streetType : "STREET"}
                         label="Тип вулиці" source="residenceAddress.streetType" validate={required.validateRequired} choices={streetTypes} />
                            )}
                    </FormDataConsumer>
                    <StreetAutoCompleteInputCustom formClassName="tab-content-item autocomplete help-text-custom" label="Назва вулиці" optionValue="name" source="residenceAddress.street" validate={required.validateRequired} />
                    <TextInput formClassName="tab-content-item" label="Будинок та номер корпусу" source="residenceAddress.building" validate={validationFunc} />
                    <TextInput formClassName="tab-content-item" label="Офіс" source="residenceAddress.apartment" validate={validationFunc} />
                    <TextInput formClassName="tab-content-item" label="Поштовий індекс" source="residenceAddress.zip" validate={required.validateRequiredZip} />
                </FormTab>

                <FormTab label={<span>Телефони <sup>*</sup></span>}>
                    <TextInput formClassName="tab-content-item" label="Номер мобільного телефону" source="mobilePhoneNumber" placeholder="+380NNNNNNNNN" validate={required.validatePhone} />
                    <TextInput formClassName="tab-content-item" label="Номер стаціонарного телефону" source="stationaryPhoneNumber" placeholder="+380NNNNNNNNN" validate={required.validatePhone} />
                </FormTab>

                <FormTab label={<span>Власник <sup>*</sup></span>}>
                    <div className="personal-data">
                        <Typography variant="h6">Особисті дані</Typography>
                        <div className={classes.personalData}>
                            <TextInput formClassName="tab-content-item" label="Прізвище" source="owner.lastName" validate={required.validateRequiredName} />
                            <TextInput formClassName="tab-content-item" label="Ім'я" source="owner.firstName" validate={required.validateRequiredName} />
                            <TextInput formClassName="tab-content-item" label="По батькові" source="owner.secondName" validate={validationFuncName} />
                            <SelectInput formClassName="tab-content-item" label="Стать" source="owner.gender" validate={required.validateRequired}  choices={[
                                { id: 'MALE', name: 'чоловік' },
                                { id: 'FEMALE', name: 'жінка' }
                            ]} />
                            <DateInput formClassName="tab-content-item" label="Дата народження" source="owner.birthDate" validate={required.validateRequiredDate} />
                            {/*<TextInput formClassName="tab-content-item" label="Ідентифікаційний код" source="owner.taxId" validate={required.validateRequiredEdrpou} />*/}
                            <FormDataConsumer>
                                {({ formData, ...rest }) => (
                                    <AutocompleteInput className="tab-content-item-position" formClassName="tab-content-item" label="Посада" source="owner.position" fullwidth={true} validate={required.validateRequired} choices={
                                        formData.edrpou && formData.edrpou.length === 10 ?
                                            [
                                                {id: 'P26' , name: 'ФОП'},
                                                {id: 'P1' , name: 'Генеральний директор'},
                                                {id: 'P2' , name: 'Директор'},
                                                {id: 'P4' , name: 'Начальник'},
                                                {id: 'P5' , name: 'Завідувач'},
                                                {id: 'P18' , name: 'Заступники з числа фармацевтів (завідувача, начальника)'},
                                                {id: 'P19' , name: 'Завідувач аптечного пункту'},
                                                {id: 'P22' , name: 'Комерційний директор'},
                                                {id: 'P23' , name: 'в.о. генерального директора'},
                                                {id: 'P24' , name: 'в.о. директора'},
                                                {id: 'P230' , name: 'т.в.о. директора'}
                                            ] :
                                            [
                                                {id: 'P1' , name: 'Генеральний директор'},
                                                {id: 'P2' , name: 'Директор'},
                                                {id: 'P4' , name: 'Начальник'},
                                                {id: 'P5' , name: 'Завідувач'},
                                                {id: 'P18' , name: 'Заступники з числа фармацевтів (завідувача, начальника)'},
                                                {id: 'P19' , name: 'Завідувач аптечного пункту'},
                                                {id: 'P22' , name: 'Комерційний директор'},
                                                {id: 'P23' , name: 'в.о. генерального директора'},
                                                {id: 'P24' , name: 'в.о. директора'},
                                                {id: 'P230' , name: 'т.в.о. директора'}

                                                // {id: 'P231' , name: 'Керівник'}
                                            ]

                                    } />
                                )}
                            </FormDataConsumer>
                            <div formClassName="tab-content-item">
                                <BooleanInput className="tab-content-item-half" label="Немає ідентфікаціонного коду" source="owner.noTaxId" />
                                <FormDataConsumer>
                                    {({ formData, ...rest }) => formData.owner && formData.owner.noTaxId ?
                                        <TextInput className="tab-content-item-half" label="Номер паспорта" source="owner.tax_id" validate={required.validateRequiredPassport} /> :
                                        <TextInput className="tab-content-item-half" label="Ідентифікаційний код" source="owner.tax_id" validate={required.validateRequiredEdrpou} />
                                    }
                                </FormDataConsumer>
                            </div>
                        </div>
                    </div>

                        <div className={classes.personalData}>
                            <Typography variant="h6" style={{width: '100%'}}>Документи</Typography>
                            <SelectInput formClassName="tab-content-item" label="Тип документу" source="owner.documents[0].type" validate={required.validateRequired} choices={
                                    [
                                        { id: 'PASSPORT', name: 'Паспорт громадянина України' },
                                        { id: 'NATIONAL_ID', name: 'Біометричний паспорт громадянина України' },
                                        { id: 'PERMANENT_RESIDENCE_PERMIT', name: 'Посвідка на постійне проживання в Україні' },
                                        { id: 'TEMPORARY_CERTIFICATE', name: 'Посвідка на проживання' },
                                        { id: 'TEMPORARY_PASSPORT', name: 'Тимчасове посвідчення громадянина України' }
                                    ]
                            } />
                            <TextInput formClassName="tab-content-item" label="Номер документу" source="owner.documents[0].number" validate={required.validateRequired} />
                            <TextInput formClassName="tab-content-item" label="Ким виданий" source="owner.documents[0].issuedBy" validate={required.validateRequired} />
                            <DateInput formClassName="tab-content-item" label="Дата видачі" source="owner.documents[0].issuedAt" validate={required.validateRequiredDate} />
                        </div>

                        <div className={classes.contacts}>
                            <Typography variant="h6">Контакти</Typography>
                            <TextInput className="contacts-email-field" label="E-mail" source="owner.email" validate={required.validateRequired} fullWidth={true} />
                            <PhoneArrayInput label="Телефони" source="owner.phones" validate={required.validateRequired} fullWidth={true} />
                        </div>

                </FormTab>

                <FormTab contentClassName="legal-entities-tab-content" label={<span>Ліцензія <sup>*</sup></span>}>
                    {licenseId && <TextInput formClassName="tab-content-item" label="ID лицензии *" source="license.id" />}
                    {!licenseId && <TextInput formClassName="tab-content-item" label="Ким видана *" source="license.issuedBy" />}
                    {!licenseId && <DateInput formClassName="tab-content-item" label="Дата видачі ліцензії *" source="license.issuedDate" />}
                    {!licenseId && <DateInput formClassName="tab-content-item" label="Початок дії ліцензії *" source="license.activeFromDate" />}
                    {!licenseId && <DateInput formClassName="tab-content-item" label="Ліцензія діє до" source="license.expiryDate"  />}
                    {!licenseId && <TextInput formClassName="tab-content-item" label="Серія та номер ліцензії" source="license.licenseNumber" />}
                    {!licenseId && <TextInput formClassName="tab-content-item" label="Вид діяльності, що ліцензовано" source="license.whatLicensed" />}
                    {!licenseId && <TextInput formClassName="tab-content-item" label="Номер наказу *" source="license.orderNo" />}

                    <BooleanInput formClassName="tab-content-item" label="Або ввести ID ліцензії " source="license.variant" onChange={handleLicenseClick} />
                </FormTab>

                <Dialog
                    open={dialogOpen}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Введений ЄДРПОУ або ІПН вже зареєстровані в системі. Бажаєте завантажити інформацію в реєстраційну форму
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <ButtonMui onClick={handleClose} color="primary">
                            Ні, не потрібно
                        </ButtonMui>
                        <ButtonMui onClick={handleClick} color="primary" autoFocus>
                            Так, заповнити поля інформацією з бази
                        </ButtonMui>
                    </DialogActions>
                </Dialog>
            </TabbedForm>
        </Create>
    );
};

export default LegalEntityCreate;
